import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Flex, Button } from 'ui';
import { blockNavigation, setPromptInfo } from '../common/navigation/containers/navigation-actions';

const Buttons = styled(Flex)`
  margin-top: 25px;
  justify-content: space-between;
`;

const StyledButton = styled(Button)`
  text-transform: uppercase;
`;

const Prompt = ({
  when,
  message,
  intl,
  callback,
  baseUrl,
}) => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { promptInfo } = useSelector(state => state.navigation);
  const dispatch = useDispatch();

  useEffect(() => () => {
    dispatch(blockNavigation(false));
    dispatch(setPromptInfo(null));
  }, []);

  useEffect(() => {
    dispatch(blockNavigation(when));
  }, [when]);

  useEffect(() => {
    if (promptInfo && Object.keys(promptInfo)?.length) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [promptInfo]);

  const handleClose = () => {
    dispatch(setPromptInfo(null));
  };

  const handleConfirm = () => {
    const url = `${baseUrl ? `/${baseUrl}/` : ''}${promptInfo?.url}`;
    if (callback) {
      callback();
    }
    if (promptInfo?.replace) {
      if (promptInfo?.state) {
        navigate(url, { replace: true, state: { ...promptInfo?.state } });
      }
      navigate(url, { replace: true });
    } else {
      if (promptInfo?.state) {
        navigate(url, { state: { ...promptInfo?.state } });
      }
      navigate(url);
    }
    dispatch(blockNavigation(false));
    dispatch(setPromptInfo(null));
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'common.SURE' })}
      open={visible}
      footer={null}
      destroyOnClose={true}
      onCancel={handleClose}
    >
      {message}
      <Buttons>
        <StyledButton onClick={handleClose}>
          <FormattedMessage id='common.CANCEL' />
        </StyledButton>
        <StyledButton type='secondary' onClick={handleConfirm}>
          <FormattedMessage id='common.CONFIRM' />
        </StyledButton>
      </Buttons>
    </Modal>
  );
};

Prompt.propTypes = {
  when: PropTypes.bool,
  message: PropTypes.string,
  intl: PropTypes.object,
  callback: PropTypes.func,
  baseUrl: PropTypes.string,
};

export default injectIntl(Prompt);
